<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title">CONTENTS</h1>
<p class="toc-text"><a href="#/Introduction">Introduction</a></p>
<p class="toc-text"><span href="#/Chapter1" title="Link target outside of Sample"><b>Slouchy beanie</b></span></p>
<p class="toc-text"><span href="#/Chapter2" title="Link target outside of Sample"><b>Hexie rug</b></span></p>
<p class="toc-text"><span href="#/Chapter3" title="Link target outside of Sample"><b>Statement necklace</b></span></p>
<p class="toc-text"><span href="#/Chapter4" title="Link target outside of Sample"><b>Moroccan pouffe</b></span></p>
<p class="toc-text"><span href="#/Chapter5" title="Link target outside of Sample"><b>Mahoooosive blanket</b></span></p>
<p class="toc-text"><span href="#/Chapter6" title="Link target outside of Sample"><b>Colour block cowl</b></span></p>
<p class="toc-text"><span href="#/Chapter7" title="Link target outside of Sample"><b>Jute plant holder</b></span></p>
<p class="toc-text"><span href="#/Chapter8" title="Link target outside of Sample"><b>Scottie dog cushion</b></span></p>
<p class="toc-text"><span href="#/Techniques#T1" title="Link target outside of Sample">Techniques</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?9e69710e